import { z } from 'zod';
import { documentsInstanceSourceReferenceSchema, documentsInstanceStatusSchema, documentsSha256Schema, } from './documents-instance.contract.js';
export const documentsInsuranceClaimsNoticeArtifactCapability = 'documents.insurance-claim-notice-artifact.v1';
export const documentsInsuranceClaimsNoticeArtifactSlot = 'insurance-claims.notice-artifact';
export const documentsInsuranceClaimsNoticeArtifactProviderId = 'documents.server.insurance-claims-notice-artifact';
const idSchema = z.string().uuid();
export function documentsInsuranceClaimsNoticeArtifactSourceResourceId(input) {
    const value = z.strictObject({ noticeId: idSchema, projectId: idSchema }).parse({
        noticeId: input.noticeId,
        projectId: input.projectId,
    });
    return `${value.projectId}:${value.noticeId}`;
}
export function documentsInsuranceClaimsNoticeArtifactSourceReference(input) {
    return documentsInstanceSourceReferenceSchema.parse({
        capability: 'insurance-claims.aob-notices.v1',
        resourceType: 'insurance-claims.aob-notice',
        resourceId: documentsInsuranceClaimsNoticeArtifactSourceResourceId(input),
        displayLabel: input.displayLabel ?? null,
    });
}
export const documentsInsuranceClaimsNoticeArtifactRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(documentsInsuranceClaimsNoticeArtifactCapability),
    resourceType: z.literal('insurance-claims.aob-notice'),
    resourceId: idSchema,
    projectId: idSchema,
});
const documentsInsuranceClaimsNoticeSignatureFactSchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('missing') }),
    z.strictObject({
        state: z.literal('present'),
        signatureId: idSchema,
        signatureSha256: documentsSha256Schema,
        signedAt: z.string().datetime({ offset: true }),
    }),
]);
const documentsInsuranceClaimsNoticeFinalArtifactSchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('missing') }),
    z.strictObject({
        state: z.literal('present'),
        objectId: idSchema,
        contentType: z.string().trim().min(1).max(255),
        sizeBytes: z.number().int().positive().safe(),
        sha256: documentsSha256Schema,
        verifiedAt: z.string().datetime({ offset: true }),
        attachedAt: z.string().datetime({ offset: true }),
    }),
]);
export const documentsInsuranceClaimsNoticeArtifactFactSchema = z.strictObject({
    capability: z.literal(documentsInsuranceClaimsNoticeArtifactCapability),
    noticeId: idSchema,
    instanceId: idSchema,
    sourceVersion: z.number().int().positive(),
    contentHash: documentsSha256Schema,
    status: documentsInstanceStatusSchema,
    signature: documentsInsuranceClaimsNoticeSignatureFactSchema,
    artifact: documentsInsuranceClaimsNoticeFinalArtifactSchema,
    observedAt: z.string().datetime({ offset: true }),
});
export const documentsInsuranceClaimsNoticeArtifactResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(documentsInsuranceClaimsNoticeArtifactCapability),
    noticeId: idSchema,
    facts: z.array(documentsInsuranceClaimsNoticeArtifactFactSchema).max(500),
}).superRefine((value, context) => {
    const instanceIds = value.facts.map(({ instanceId }) => instanceId);
    if (new Set(instanceIds).size !== instanceIds.length) {
        context.addIssue({
            code: 'custom',
            path: ['facts'],
            message: 'Notice artifact facts must contain each document instance once.',
        });
    }
    value.facts.forEach((fact, index) => {
        if (fact.noticeId !== value.noticeId) {
            context.addIssue({
                code: 'custom',
                path: ['facts', index, 'noticeId'],
                message: 'Notice artifact facts must belong to the requested notice.',
            });
        }
    });
});
//# sourceMappingURL=documents-insurance-claims-notice-artifact.contract.js.map